import { is, map } from 'ramda';
/**
 * Removes whitespaces (trims) from both ends of a string, string in an array, or string as an object property value.
 * @param {string|string[]|object} value - Value that should be trimmed.
 * @returns {string} - Trimmed string.
 */
const trimValues = (value) => {
    if (is(String, value)) {
        return value.trim();
    }
    if (is(Array, value) || is(Object, value)) {
        return map(trimValues, value);
    }
    return value;
};
export default trimValues;
//# sourceMappingURL=trimValues.js.map